<template>
  <br />
  <div id="parallax-world-of-ugg">
    <br />
    <section>
      <div class="img">
        <img class="" src="/TES Image new.png" alt="img" />
      </div>
      <br />
      <div class="page-break"></div>
      <div class="block">
        <div id="circle-shape-example">
          <img
            src="/TES round image.jpg"
            alt="pic"
            class="curve"
            loading="lazy"
          />
          <br />
          <p
            class="main-info"
            style="font-size: 20px; line-height: 1.6; color: #333"
          >
            <strong>TES - TNG ENTERPRISE SERVER</strong> is designed to enhance
            the functionality of a single TNG installation, making it ideal for
            enterprise-level environments. It allows businesses to consolidate
            multiple branches into a unified company view, offering
            <strong>CONSOLIDATED REPORTING</strong> for seamless oversight
            across all locations.
          </p>
          <p
            class="main-info"
            style="font-size: 20px; line-height: 1.6; color: #333"
          >
            With <strong>ENHANCED FUNCTIONALITY</strong> , TES improves control,
            scalability, and management efficiency. It also supports
            <strong>MASS REPORTING,</strong> enabling large-scale data
            extraction and distribution across departments with ease, ensuring
            consistent and centralized communication monitoring.
          </p>
          <br />
          <br />
        </div>
        <br />
        <br />
        <br />
        <h5>Here's why TES will help you and your team...</h5>
        <br />
        <br />
        <div class="D1 section-flex">
          <img
            src="/TES Sceenshot 1.png"
            alt="Recording"
            class="section-image"
            loading="lazy"
          />
          <div>
            <h1>Accessibility and Reports</h1>
            <ul>
              <li>User-friendly web-based user interface.</li>
              <li>Allow users to access their own information.</li>
              <li>
                Provides extensive detail and summary reports in HTML, PDF, and
                CSV format.
              </li>
              <li>
                Provides abuse reports on cost, duration, most expensive calls,
                most dialled numbers, longest duration, pair analysis, and
                longest ring time.
              </li>
            </ul>
            <li>
              Accessible from anywhere on the network through your standard Web
              browser.
            </li>
            <li>
              Allows you to automatically schedule PDF, HTML and CSV reports.
            </li>
            <li>Mass PDF reports.</li>
          </div>
        </div>

        <br />
        <br />
        <br />

        <div class="D2 section-flex">
          <div>
            <h1>Team Management</h1>
            <ul>
              <li>
                Supports unlimited user logins, allowing organizations to scale
                access as needed without licensing limitations.
              </li>
              <li>
                Multiple users can access the system simultaneously, enabling
                efficient collaboration and real-time monitoring across
                departments.
              </li>
              <li>
                Includes a centralized company phonebook with easy import and
                export capabilities via CSV files for streamlined contact
                management.
              </li>
              <li>
                Allows for account code allocation to classify calls accurately,
                with optional user notifications to keep teams informed of
                assigned codes or changes.
              </li>
              <li>
                Provides automatic number identification with real-time email
                notifications to alert users of specific incoming or outgoing
                calls for improved awareness and tracking.
              </li>
            </ul>
          </div>
          <img
            src="/TES Screenshot 2.png"
            alt="Search and Playback"
            class="section-image"
            loading="lazy"
          />
        </div>

        <br />
        <br />
        <br />

        <div class="D3 section-flex">
          <img
            src="/TES Screenshots 3.png"
            alt="Search and Playback"
            class="section-image"
            loading="lazy"
          />
          <div>
            <h1>Technical Management</h1>
            <ul>
              <li>
                Designed for ease of management and maintenance, requiring
                minimal technical expertise for day-to-day operation and system
                upkeep.
              </li>
              <li>
                Offers full support for both physical and virtual server
                environments, providing flexibility to match your IT
                infrastructure.
              </li>
              <li>
                Capable of handling multiple PABXs across various branches and
                departments, ensuring centralized control and consistent
                performance across your organization.
              </li>
              <li>
                Optional Active Directory integration is available, allowing for
                streamlined user authentication and simplified access
                management.
              </li>
              <li>
                Call recording storage is only limited by available hardware
                resources, enabling virtually unlimited record-keeping based on
                your system capacity.
              </li>
            </ul>
          </div>
        </div>
        <br />
        <div class="buttton">
          <div class="button" data-tooltip="Please Click">
            <div class="button-wrapper">
              <div class="text">TES Brochures</div>
              <a
                href="/TES Brochure.pdf"
                class="icon"
                target="_blank"
                rel="noopener noreferrer"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  width="2em"
                  height="2em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <br />
      </div>
    </section>
    <br />
  </div>
</template>

<script>

</script>

<style scoped>
.page-break {
  page-break-before: always;
  border: 1px solid darkgreen;
  width: 80%;
  margin-left: 10%;
  justify-content: center;
}

.section-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  width: 80%;
  margin-left: 10%;
}

.section-image {
  width: 400px;
  height: auto;
  margin-right: 20px;
  flex-shrink: 0;
  border-radius: 25px;
  box-shadow: 0 5px 20px #333;
  transition: 0.3s ease-in-out;
}

.section-image:hover {
  transform: scale(1.1);
}

/* Typography */
/**************************/
h1 {
  font-size: 22px;
  color: darkgreen;
  font-size: 24px;
  background-color: gold;
  padding: 5px;
}

#parallax-world-of-ugg h5 {
  font-size: 28px;
  color: black;
  background-color: darkgreen;
  border-radius: 0 20px 0 20px;
  color: white;
  padding: 8px;
  margin: 0;
}

#parallax-world-of-ugg h3 {
  font-size: 20px;
  line-height: 0;
  font-weight: 400;
  letter-spacing: 8px;
  color: black;
}

#parallax-world-of-ugg li {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #333;
}

/* Section - Title */
/**************************/
#parallax-world-of-ugg .title {
  background: white;
  padding: 60px;
  margin: 0 auto;
  text-align: center;
}

#parallax-world-of-ugg .title h1 {
  font-size: 30px;
  letter-spacing: 5px;
}

/* Section - Block */
/**************************/
#parallax-world-of-ugg .block {
  background: white;
  padding: 30px;
  width: 80%;
  margin: 0 auto;
  text-align: left;
}

.img {
  text-align: center;
}

.img img {
  width: 400px;
}
#circle-shape-example {
  margin: 1rem;
}
#circle-shape-example p {
  line-height: 1.6;
  text-align: justify;
  text-justify: inter-word;
}
#circle-shape-example .curve {
  width: 280px;
  height: 260px;
  min-width: 150px;
  float: left;
  margin-right: 3rem;
  border-radius: 50%;
  -webkit-shape-outside: circle();
  shape-outside: circle();
  border: 5px solid darkgreen;
  box-shadow: 0 5px 20px #333;
}

/* ----- Brochure ----- */

.buttton {
  display: flex;
  justify-content: center;
}

.button {
  --width: 320px;
  --height: 80px;
  --tooltip-height: 35px;
  --tooltip-width: 90px;
  --gap-between-tooltip-to-button: 18px;
  --button-color: darkgreen;
  --tooltip-color: #fff;
  width: var(--width);
  font-size: 30px;
  height: var(--height);
  background: var(--button-color);
  position: relative;
  text-align: center;
  border-radius: 0 40px 0 40px;
  box-shadow: 0 5px 30px darkgreen;
  transition: background 0.3s;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}
.button:hover {
  border-radius: 40px 0 40px 0;
  box-shadow: 0 5px 50px darkgreen;
}

.button::before {
  position: absolute;
  content: attr(data-tooltip);
  width: var(--tooltip-width);
  height: var(--tooltip-height);
  background-color: var(--tooltip-color);
  font-size: 0.9rem;
  color: #111;
  line-height: var(--tooltip-height);
  bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) + 10px);
  left: calc(50% - var(--tooltip-width) / 2);
}

.button::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: var(--tooltip-color);
  left: calc(50% - 10px);
  bottom: calc(100% + var(--gap-between-tooltip-to-button) - 10px);
}

.button::after,
.button::before {
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s;
}

.text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-wrapper,
.text,
.icon {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  color: #fff;
}

.text {
  top: 0;
}

.text,
.icon {
  transition: top 0.5s;
}

.icon {
  color: #fff;
  top: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon svg {
  width: 50px;
  height: 50px;
}

.button:hover {
  background: rgb(0, 64, 0);
}

.button:hover .text {
  top: -100%;
}

.button:hover .icon {
  top: 0;
}

.button:hover:before,
.button:hover:after {
  opacity: 1;
  visibility: visible;
}

.button:hover:after {
  bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) - 20px);
}

.button:hover:before {
  bottom: calc(var(--height) + var(--gap-between-tooltip-to-button));
}

/*-------------- Media Queries --------------*/
@media screen and (max-width: 959px) and (min-width: 768px) {
  #parallax-world-of-ugg .block {
    padding: 40px;
    width: 620px;
  }
}
@media screen and (max-width: 767px) {
  #parallax-world-of-ugg .block {
    padding: 30px;
    width: 420px;
  }
  #parallax-world-of-ugg h2 {
    font-size: 30px;
  }
  #parallax-world-of-ugg .block {
    padding: 30px;
  }
  #parallax-world-of-ugg .parallax-one,
  #parallax-world-of-ugg .parallax-two,
  #parallax-world-of-ugg .parallax-three {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
@media screen and (max-width: 479px) {
  #parallax-world-of-ugg .block {
    padding: 30px 15px;
    width: 290px;
  }
  #circle-shape-example .curve {
    width: 100px;
    height: 120px;
  }
  .section-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .section-image {
    width: 200px;
  }
  #parallax-world-of-ugg li {
    font-size: 15px;
    line-height: 20px;
  }
  .start-info {
    font-size: 18px;
  }
  #parallax-world-of-ugg h5 {
    font-size: 20px;
  }
  #circle-shape-example p {
    font-size: 18px;
    text-align: justify;
  }
  .img img {
    width: 100%;
  }
}
</style>
